import React from 'react';
import classNames from 'classnames';
import { AvatarWithInitials } from 'components/AvatarWithInitials';
import { useTranslation } from 'react-i18next';
import { SIZE } from 'models/Size';
import { User } from 'models/User';
import utils, { getMemberInitials, getUserFullName } from 'utils';
import usePastTime from 'hooks/usePastTime';
import { LeadBasicInfo } from 'router/subrouters/DataRoom/models/Dashboard';
import { getLeadName } from '../../utils';

import './LeadInfo.styles.scss';

type LeadInfoProps = {
  className?: string;
  lastSeen?: Date;
  lastSession?: number;
} & Pick<User, 'avatarColor'> &
  LeadBasicInfo;

const LeadInfo: React.FC<LeadInfoProps> = (props) => {
  const {
    className,
    firstName,
    lastName,
    email,
    lastSeen,
    lastSession,
    avatarColor,
  } = props;

  const classes = classNames('lead-info', className);

  const { t } = useTranslation();

  const pastTime = usePastTime();

  const name = getUserFullName(firstName, lastName);

  const { type, count } = utils.timeSpentInSecondsHumanize(lastSession, true);

  return (
    <div className={classes}>
      <AvatarWithInitials
        className="lead-info__avatar"
        color={avatarColor}
        size={SIZE.BIG}
        initials={getMemberInitials(name)}
      />

      <div className="lead-info__content">
        <p className="lead-info__name">
          {getLeadName({ firstName, lastName, email })}
        </p>

        <div className="lead-info__meta">
          {lastSeen ? (
            <p>{t('lastSeenDate', { date: pastTime(lastSeen) })}</p>
          ) : (
            <p>{t('hasntAccessedyet')}</p>
          )}

          {!!lastSession && (
            <p>{`${t(`timeSpentInSecondsHumanizeShort.${type}`, { count })} ${t(
              'lastSession',
            )}`}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadInfo;
